import { Injectable } from '@angular/core';
import { EmailAccountSignatureType } from './email-account-signature-type.enum';
import { NotificationBarService } from '../../../../../../shared/services/notification/notification-bar.service';
import { BcRestApi } from '../../../../../../common/api/rest-api';
import { BcAnalytics } from '../../../../../../common/analytics/analytics.service';
import { LogoutSubscriber } from '../../../../../../shared/services/subscribers/logout-subscriber.service';

@Injectable()
export class EmailAccountsService {
  private _emailAccountSignaturesCache;
  private _emailAccounts;

  constructor(private _bcRestApi: BcRestApi,
              private _bcAnalytics: BcAnalytics,
              private _bcNotificationService: NotificationBarService,
              private _logoutSubscriber: LogoutSubscriber) {

    this._logoutSubscriber.subscribe(this._clearCache.bind(this));

    this._emailAccountSignaturesCache = {};
  }

  public getEmailAccounts() {
    return this._emailAccounts || this._loadEmailAccounts();
  }

  public reloadEmailAccounts() {
    this._emailAccounts = undefined;

    return this.getEmailAccounts();
  }

  public getEmailAccountSignature(emailAccountId): Promise<any> {
    return new Promise((resolve, reject) => {
      const cachedSignature = this._emailAccountSignaturesCache[emailAccountId];

      if (cachedSignature) {
        resolve(cachedSignature);
        return;
      }

      this._bcRestApi.getEmailAccountSignature(emailAccountId)
        .then((signature) => {
          const normalizedSignature = {
            type: signature.type === EmailAccountSignatureType.Never ? EmailAccountSignatureType.Never : EmailAccountSignatureType.Always,
            contentAsHtml: signature.html || `<p>${signature.text}</p>`
          };

          this._emailAccountSignaturesCache[emailAccountId] = normalizedSignature;
          resolve(normalizedSignature);
        })
        .catch(reject);
    });
  }

  private _loadEmailAccounts() {
    this._emailAccounts = this._bcRestApi.getEmailAccounts().then(this._sanitizeEmailAccountsResponse.bind(this));

    return this._emailAccounts;
  }

  private _sanitizeEmailAccountsResponse(emailAccountsResponse) {
    let emailAccounts;

    if (emailAccountsResponse && emailAccountsResponse.length > 0) {
      emailAccounts = emailAccountsResponse;
    } else {
      this._bcAnalytics.eventTrack('EmailAccountListEmpty');
      this._bcNotificationService.addNotification({ id: 'email-account-missing', content: 'bcEmailCompose.emailAccountMissing' });
    }

    return emailAccounts;
  }

  private _clearCache() {
    this._emailAccounts = undefined;
    this._emailAccountSignaturesCache = {};
  }
}
